// src/lib/validation.ts — forma UNICĂ a rezultatului de validare fail-closed (PUR, partajat
// server↔client): folosită de lib/filters, lib/basemaps, lib/attribute_schema. Diferă intenționat de
// RESULT din lib/safe (acela e contractul serviciilor/API; aici e un helper de formă, fără `_op`).

export type Validation<T> = { ok: true; value: T } | { ok: false; error: string }

/** Ramura de eșec — mesaj RO, gata de concatenat cu poziția/contextul de către apelant. */
export const validation_error = (error: string): { ok: false; error: string } => ({
	ok: false,
	error,
})
